export class FilterValues
{
    constructor (public filterKey: string, public rootValues: string[])
    {
    }
}
